/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UndoDeclineShiftCoverRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {UndoDeclineShiftCoverResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const undoDeclineShiftCover = (request: UndoDeclineShiftCoverRequest, options?: CashRequestOptions) => post<UndoDeclineShiftCoverRequest, UndoDeclineShiftCoverResponse>("/2.0/cash/undo-decline-shift-cover", request, {...options, rejectOnError: true })